import { useMemo } from 'react';
import { Experiment } from '@amplitude/experiment-js-client';
import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';

const AMPLITUDE_API_KEYS = {
  [ENVS.QA]: 'to-be-defined',
  [ENVS.STAGING]: 'to-be-defined',
  [ENVS.PRODUCTION]: 'to-be-defined',
};

const useAmplitude = () => {
  const env = getEnv();
  const apiKey = useMemo(() => AMPLITUDE_API_KEYS[env], [env]);
  const experiment = useMemo(() => Experiment?.initialize(apiKey), [apiKey]);

  const fetchUserVariant = async (experimentUser) => {
    await experiment.fetch(experimentUser);
  };

  const lookupFlagVariant = (flagKey) => {
    const variant = experiment.variant(flagKey);
    if (variant.value === 'on') {
      return true;
    }
    return false;
  };

  return { experiment, lookupFlagVariant, fetchUserVariant };
};

export default useAmplitude;
